import { Menu, Select } from 'antd'
import { useSelector } from 'react-redux'
import { faExclamationTriangle, faFilter, faSignal } from '@fortawesome/pro-solid-svg-icons'

import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isNonEmptyArray } from '../../../utils'
import { getSeverityTag, getStatusTag, getTypeLabel, Severities, Statuses, Types } from '../../../utils/entities/aphmAnomaly'

import '../../../assets/aphm-anomaly-filters.scss'

const SELECTOR_CLASS = 'aphm-anomaly-filter-select'
const SELECTOR_STYLE = { width: '230px' }
/** The labels are longer than the field itself, so the dropdown is left free to grow to their width. */
const DROPDOWN_STYLE = { minWidth: '230px' }
const MENU_ITEM_STYLE = { cursor: 'default', height: 'auto', lineHeight: 1.5, overflow: 'visible', padding: '4px 16px' }

export const DEFAULT_APHM_ANOMALY_FILTERS = Object.freeze({
  status: Statuses.OPEN,
  severity: [],
  type: []
})

export const getActiveFiltersCount = filters => {
  const state = filters ?? {}
  let count = 0

  if (state.status) { count += 1 }
  if (isNonEmptyArray(state.severity)) { count += 1 }
  if (isNonEmptyArray(state.type)) { count += 1 }

  return count
}

/** The title is what antd shows on hover, on the dropdown row as well as on the chip of a picked value. */
const renderOption = (value, label) => <Select.Option key={value} value={value} title={label}>{label}</Select.Option>

const AphmAnomalyFilters = ({ filters, onFiltersChange }) => {
  const t = useSelector(selectTranslate)

  const change = (key, value) => onFiltersChange({ ...filters, [key]: value })

  return (
    <Menu>
      <Menu.Item key='status' style={MENU_ITEM_STYLE}>
        <IconLabel icon={faFilter} fontSize={FontSizes.SMALL} text={t('common.status')} />
        <Select
          allowClear
          className={SELECTOR_CLASS}
          style={SELECTOR_STYLE}
          dropdownMatchSelectWidth={false}
          dropdownStyle={DROPDOWN_STYLE}
          value={filters?.status ?? undefined}
          placeholder={t('aphm_anomaly.filters.any_status')}
          onChange={value => change('status', value ?? null)}
        >
          {Object.values(Statuses).map(status => renderOption(status, t(getStatusTag(status).label)))}
        </Select>
      </Menu.Item>

      <Menu.Item key='severity' style={MENU_ITEM_STYLE}>
        <IconLabel icon={faSignal} fontSize={FontSizes.SMALL} text={t('aphm_anomaly.severity_label')} />
        <Select
          mode='multiple'
          allowClear
          className={SELECTOR_CLASS}
          style={SELECTOR_STYLE}
          dropdownMatchSelectWidth={false}
          dropdownStyle={DROPDOWN_STYLE}
          value={filters?.severity ?? []}
          placeholder={t('aphm_anomaly.filters.any_severity')}
          onChange={value => change('severity', value)}
        >
          {Object.values(Severities).map(severity => renderOption(severity, t(getSeverityTag(severity).label)))}
        </Select>
      </Menu.Item>

      <Menu.Item key='type' style={MENU_ITEM_STYLE}>
        <IconLabel icon={faExclamationTriangle} fontSize={FontSizes.SMALL} text={t('common.type')} />
        <Select
          mode='multiple'
          allowClear
          className={SELECTOR_CLASS}
          style={SELECTOR_STYLE}
          dropdownMatchSelectWidth={false}
          dropdownStyle={DROPDOWN_STYLE}
          value={filters?.type ?? []}
          placeholder={t('aphm_anomaly.filters.any_type')}
          onChange={value => change('type', value)}
        >
          {Object.values(Types).map(type => renderOption(type, t(getTypeLabel(type))))}
        </Select>
      </Menu.Item>
    </Menu>
  )
}

export default AphmAnomalyFilters
